import styled from 'styled-components';
import { mediaQuery } from 'modules/utils';
import { CSSTransition } from 'react-transition-group';
import { Button } from '../button';
import { theme } from '../theme';

interface StyledModalProps {
  width?: string;
  height?: string;
}

export const StyledModalTransitions = styled(CSSTransition)`
  &.modal-enter {
    opacity: 0;
  }

  &.modal-enter-active {
    opacity: 1;
    transition: opacity 200ms ease-in;
  }

  &.modal-exit {
    opacity: 1;
  }

  &.modal-exit-active {
    opacity: 0;
    transition: opacity 200ms ease-out;
  }
`;

export const StyledModalBackdrop = styled.div<StyledModalProps>`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  width: 100vw;
  height: 100vh;

  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colors.backdrop};
`;

export const StyledModalContainer = styled.div<StyledModalProps>`
  background-color: ${theme.colors.primaryW};
  border-radius: 0.4rem;

  padding: 1.4rem;
  margin: 0 0.938rem;
  width: 90%;

  ${mediaQuery('md')} {
    padding: 1.875rem 2.5rem;
    ${(props) => (props.width ? `width: ${props.width}` : 'width: 50rem')};
    ${(props) => (props.width ? `height: ${props.height}` : '')};
  }

  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: ${theme.colors.primaryW};
`;

export const StyledModalHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const StyledTextContainer = styled.div`
  margin-bottom: 1.4rem;
`;

export const StyledButtonContainer = styled.div<StyledModalProps>`
  display: flex;
  width: 100%;
  flex-direction: column-reverse;

  & > *:not(:first-child) {
    margin-bottom: 1rem;
  }

  ${mediaQuery('md')} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    & > *:not(:first-child) {
      margin-bottom: 0;
    }

    > :only-child {
      align-self: flex-end;
      margin-left: auto;
    }
  }
`;

export const StyledButton = styled(Button)`
  min-width: 7.5rem;
`;
